import { Injectable } from '@angular/core';
import { rx, Subject } from '@app/shared/rx';

import {
  IEntityConfig,
  ENTITY_TYPES,
  BackendApiType,
  ObjectId,
  IDocumentOperationOptions,
  IBaseEntityType,
  EDeployStatus,
} from '@app/shared/types';
import { compact, get, head, includes, isArray, isEqual } from 'lodash';
import { throwError } from 'rxjs';

import { BaseService } from '../base';

const entityType: ENTITY_TYPES = ENTITY_TYPES.CART;
const config: IEntityConfig = {
  backendApiType: BackendApiType.DM,
  ENTITY_TYPE: entityType,
  isMasterListAvailable: true,
  apiEndpoint: entityType,
  uiRoute: entityType,
  customEntityRoute: {
    list: 'master',
  },
  buttons: {},
};

@Injectable()
export class CartService extends BaseService {
  public static config: IEntityConfig = config;
  public static ENTITY_TYPE: string = config.ENTITY_TYPE;
  public deployStatus$: Subject<EDeployStatus> = new Subject();

  private intervalFetchId: NodeJS.Timeout = null;

  public intervalFetchCart(
    entityId: ObjectId,
    timer: number = 5000,
    options: IDocumentOperationOptions = {},
  ) {
    clearTimeout(this.intervalFetchId);
    this.intervalFetchId = setTimeout(() => {
      this.fetchCartByDocumentId(entityId, options)
        .pipe(
          rx.catchError((err) => {
            this.deployStatus$.next(EDeployStatus.failed);

            return throwError(new Error(err));
          }),
        )
        .subscribe((cartDocument: IBaseEntityType) => {
          const status = get(cartDocument, 'status');
          const finalStatus: EDeployStatus[] = [
            EDeployStatus.deployed,
            EDeployStatus.failed,
          ];
          if (includes(finalStatus, status)) {
            this.deployStatus$.next(status);
            if (isEqual(status, EDeployStatus.failed)) {
              const errors = get(cartDocument, 'meta.errors', []);
              const meta = get(cartDocument, 'meta');
              const errorsData = isArray(errors) ? errors : [errors];
              const errorContext = head<object>(
                get(meta, ['errors', 'context', entityId]),
              );
              const collectedErrors = compact([...errorsData, errorContext]);

              for (const error of collectedErrors) {
                this.uiActions.showCartErrorToasterMessage(error);
              }
            }
          } else {
            this.intervalFetchCart(entityId, timer);
          }
        });
    }, timer);
  }
}
